import React from "react";
import { EuiCallOut } from "@elastic/eui";

export default function () {
    return (
        <EuiCallOut
            size="m"
            title="Access databases and create orders from left sidebar"
            iconType="pin"
        />
    );
}
